import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

const URL = environment.PROCEDURE_SECURITY_URI;
const URLVentanilla = environment.backUrlVentanilla;

@Injectable({
  providedIn: 'root'
})
export class FuncionalidadRolesService {

  constructor(private http: HttpClient) { }

  traerFuncionalidadRoles(): Observable<any[]>{
    return this.http.get<any[]>(`${ URL }/GetRolesAplications`)
  }

  traerFuncionalidadRolesById(id: string): Observable<any[]>{
    return this.http.get<any[]>(`${ URL }/GetRolesAplications?type=codigo&search=${ id }`)
  }


  consultarFuncionalidadRoles(nombre: string): Observable<any>{
    return this.http.get<any>(`${ URL }/GetRolesAplications?type=nombre&search=${ nombre }`);
  }

  desactivarFuncionalidadRoles(id: number): Observable<number>{
    return this.http.delete<number>(`${ URL }/funcionality_rol/off/${ id }`);
  }

  activarFuncionalidadRoles(id: number): Observable<number>{
    return this.http.delete<number>(`${ URL }/funcionality_rol/on/${ id }`);
  }

  guardarFuncionalidadRoles(aplicativo:any): Observable<any>{
    return this.http.post<any>(`${ URL }/PostAplication`, aplicativo);
  }

  actualizarFuncionalidadRoles(aplicativo:any): Observable<any>{
    return this.http.put<any>(`${ URL }/PutAplication`, aplicativo);
  }
  ObtenerTramitesVentanilla(data:any): Observable<any>{
    return this.http.post<any>(`${ URLVentanilla }/Paperwork/GetAll`, data);
  }
  getPersonalidadAplicable(): Observable<any> {
    return this.http.get(`${URLVentanilla}/Master/GetPaperworkCategory`);
  }

  actualizarFuncionalidadVentanilla(id:any,aplicativo:any): Observable<any>{
    return this.http.put<any>(`${ URLVentanilla}/Paperwork/`+id, aplicativo);
  }
  actualizarTramitesMainVentanilla(aplicativo:any): Observable<any>{
    return this.http.put<any>(`${ URLVentanilla }//TramitesMain/update`, aplicativo);
  }
  borrarFuncionalidadRoles(id: number): Observable<number>{
    return this.http.delete<number>(`${ URLVentanilla }/funcionality_rol/delete/${ id }`);
  }
}
